import * as React from 'react'
import {Util} from 'yougile-util'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {globals} from '@extensions/globals-base'
import {GroupChatProxy} from '@extensions/proxies/group-chat-proxy'
import {SearchResultItemType} from '@extensions/search'
import {ChatInfo, LocationType} from '../chat-info/chat-info'

export const GroupChatListItem = (
  props: GroupChatProxy & {
    highlightText?: string
    startFrom?: number
    endAt?: number
    locationType: LocationType
    highlightType?: SearchResultItemType
  }
) => {
  const bem = Util.bemFrom('task-chat-list', 'item')
  const onClick = () => {
    void Tracking.send(TrackingEvent.chatPanelClickTask)
  }
  const me = props.users.get(globals.currentUserId)
  const withMe = !!me && me.isNotified
  return (
    <div className={bem({withMe})} onClick={onClick}>
      <div className={bem('icon', {group: true})} />
      <ChatInfo {...props} withMe={withMe} type={'group'} />
    </div>
  )
}
